import { render, staticRenderFns } from "./edit-table-vuetify.vue?vue&type=template&id=6768243f"
import script from "./edit-table-vuetify.vue?vue&type=script&lang=js"
export * from "./edit-table-vuetify.vue?vue&type=script&lang=js"
import style0 from "./edit-table-vuetify.vue?vue&type=style&index=0&id=6768243f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports